import { SnackbarProvider } from '@web-chat-core/ui-kit';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';

export const MeetSnackbar = styled(SnackbarProvider)`
    bottom: 83px;

    @media screen and (min-width: 992px) {
        bottom: 108px;
    }

    // Для laptop/PC девайсов присваиваем кастомные отступы (отличные от тех, что установлены в ui-kit Snackbar),
    // для mobile И tablet девайсов внутри в ui-kit Snackbar уже есть выравнивание по центру.
    ${!isMobile &&
    `
        left: 10px;
        margin-right: 10px;
        text-align: left;
        min-width: 288px
    `};

    // этот компонент перекрывает кнопки звонка в EmbeddedIncomingCall
    // в Snackbar-ах мита нет кнопок закрыть, поэтому просто отключаем нажатия на этот компонент
    pointer-events: none;
`;
